<template>
  <div class="con">
    <div class="imgbg"></div>
    <div class="row">
      <div class="lcol">

        <baidu-map :center="center" :zoom="zoom" @ready="map_handler" class="baidu-map-view" ak="70YYFQXKHx9NOmrkRdTP9h04QCee4YKX">
          <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
        </baidu-map>
      </div>
      <div class="rcol">
        <h1>公司地址</h1>
        <p>北京市朝阳区光华路甲14号诺安基金大厦1001</p>
      </div>
    </div>
  </div>
</template>

<script>
  //百度地图
  import { BaiduMap, BmScale, BmGeolocation,BmMarker } from 'vue-baidu-map'
export default {
  data () {
    return {
      dcode: '',
      center: {lng: 0, lat: 0},
      zoom: 3
    }
  },
  components: {
    BaiduMap,
    BmGeolocation,
    BmScale,
    BmMarker
  },
  methods: {
    map_handler({ BMap, map }) {
      this.center.lng = 116.463517
      this.center.lat = 39.918819
      this.zoom = 15
    }
  },
  mounted: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .con .imgbg {width: 100%; height: 330px; background: url("../../img/bg1.jpg") center no-repeat; background-size: 100%}
  .row {width: 1200px; margin: 0 auto; margin-top: 50px}
  .row .lcol {width: 400px; height: 400px; float: left}
  .baidu-map-view {width: 400px; height: 400px; border: 1px solid #e0e0e0}
  .row .rcol {float: right; width: 770px}
  .row .rcol h1 {font-size: 18px; line-height: 40px}
  .row:after {content: ""; display: block; clear: both}
</style>



// WEBPACK FOOTER //
// src/components/children/contactus.vue